export const device = {
	isMobile() {
		return window.orientation !== undefined || /mobile/i.test(navigator.userAgent);
	},
	isTablet() {
		return this.isMobile() && screen.width >= 768 && screen.height >= 768;
	},
	isPhone() {
		return this.isMobile() && (screen.width < 768 || screen.height < 768);
	},
};
